export const OVERLAY_TEMPLATES = {
  noRowsTemplateForCompany: '<span class="ag-overlay-no-rows-center">No companies found for the current search</span>',
  noRowsTemplateForBrand: '<span class="ag-overlay-no-rows-center">No brands found for the current search</span>'
};